import FilespaceBreakdownBase, {
    FilespaceBreakdownBaseProperties
} from '../../../webportal/components/FilespaceBreakdownBase';
import { FilespaceLineItem, FilespaceUsage, Invoice } from 'fs-api-client';
import { CheckBoldIcon } from '../../../webportal/components/common/Icons';
import * as React from 'react';
import {
    downloadCSVBackoffice,
    formatDate,
    LESS_FILESPACES_COUNT
} from '../../../webportal/components/billing/breakdown/BreakdownModalHelpers';

interface InvoiceBreakdownProps extends FilespaceBreakdownBaseProperties {
    invoice: Invoice | null;
    onInvoiceModalClose: () => void;
}

interface InvoiceBreakdownState {
    currentInvoiceIdx: number;
    showAllFilespacesPerInvoice: boolean;
}

export class InvoiceBreakdownModal extends FilespaceBreakdownBase<InvoiceBreakdownProps, InvoiceBreakdownState> {
    constructor(props: InvoiceBreakdownProps) {
        super(props);

        this.state = {
            currentInvoiceIdx: 0,
            showAllFilespacesPerInvoice: false,
        };
    }

    render() {
        const currentInvoice = this.props.invoice;
        if (!currentInvoice) {
            return null;
        }
        const filespaceLineItems = currentInvoice.filespaceBreakdown ? currentInvoice.filespaceBreakdown : [];

        const periodStart = currentInvoice.periodStart ? new Date(currentInvoice.periodStart) : new Date();
        const periodEnd = currentInvoice.periodEnd ? new Date(currentInvoice.periodEnd) : new Date();

        return (
            <div className="modalBO show" id="invoiceBreakdownModal" tabIndex={-1} role="dialog" aria-labelledby="invoiceBreakdownModal" aria-hidden="true">
                <div>
                    <header className="center">
                        <h2>
                            Invoice breakdown per filespace
                        </h2>
                    </header>
                    <div>
                        <div className="modalTableHeader" >
                            <p>
                                <strong>{formatDate(periodStart)} - {formatDate(periodEnd)}</strong>
                            </p>
                            <button onClick={() => downloadCSVBackoffice(this.props.invoice)}>Export in CSV</button>
                        </div>
                        {this.renderFilespaces(filespaceLineItems)}
                    </div>
                    <footer>
                        <button
                            onClick={() => this.props.onInvoiceModalClose()}
                            data-dismiss="modal"
                            aria-label="close"
                        >
                            Close
                        </button>
                    </footer>
                </div>
            </div>
        );
    }

    renderFilespaces(filespaceLineItems: FilespaceLineItem[]) {
        let filespacesRendered = 0;
        const filespacesShowHideText = this.state.showAllFilespacesPerInvoice ? 'View less filespaces' : 'View all filespaces';
        const hasMoreFilespaces = filespaceLineItems.length > LESS_FILESPACES_COUNT;
        const columnsHeaders = this.getTableHeaders(filespaceLineItems);

        return (
            <>
                <table className="modalTable" cellPadding="0" cellSpacing="0">
                    <thead>
                    <tr>
                        <th className="left">Plan</th>
                        <th className="right">Filespace name</th>
                        <th>LucidLink Storage</th>
                        {columnsHeaders.map(header => {
                            if (header === FilespaceUsage.DimensionEnum.Storage) {
                                return null;
                            }
                            return (<th key={header} className={`hidden left`}>{this.getDescriptionForDimension(header)}</th>);
                        })}
                        <th className="left">Total</th>
                    </tr>
                    </thead>
                    <tbody>
                    {filespaceLineItems.map(fs => {
                        ++filespacesRendered;
                        if (!this.state.showAllFilespacesPerInvoice && filespacesRendered > LESS_FILESPACES_COUNT) {
                            return null;
                        }
                        return this.renderSingleFilespace(fs, columnsHeaders);
                    })}
                    </tbody>
                </table>
                {hasMoreFilespaces && (<div className="modalTableFooter">
                    <button onClick={() => this.onShowMoreFilespacesClicked()}>{filespacesShowHideText}</button>
                </div>)}
            </>
        );
    }

    renderSingleFilespace(filespaceLineItem: FilespaceLineItem, columnOrder: FilespaceUsage.DimensionEnum[]) {
        const rowClassName = filespaceLineItem.isDeleted ? 'deleted' : undefined;
        return (
            <tr className={rowClassName}>
                {this.renderStorageType(filespaceLineItem)}
                <td className="right">
                    <strong>{filespaceLineItem.name}</strong>
                    {filespaceLineItem.isDeleted && <span>deleted</span>}
                </td>
                {filespaceLineItem.storageOwner === FilespaceLineItem.StorageOwnerEnum.Lucidlink ?
                    (<td key={filespaceLineItem.name + FilespaceUsage.DimensionEnum.Storage}>
                        <CheckBoldIcon width="15px"/>
                    </td>) : (
                        <td key={filespaceLineItem.name + FilespaceUsage.DimensionEnum.Storage} className="hidden"/>)
                }
                {columnOrder.filter(column => column !== FilespaceUsage.DimensionEnum.Storage).map((column: FilespaceUsage.DimensionEnum) => {
                    const dimensionUsage = filespaceLineItem.usageByDimension.find(usage => usage.dimension === column);
                    return (<td key={column} className="hidden">
                        {dimensionUsage && this.renderUsage(dimensionUsage.dimension, dimensionUsage.usage)}
                    </td>);
                })}
                <td>${(filespaceLineItem.amountDue / 100).toFixed(2)}</td>
            </tr>);
    }

    onShowMoreFilespacesClicked() {
        this.setState({
                          showAllFilespacesPerInvoice: !this.state.showAllFilespacesPerInvoice
                      });
    }
}



// WEBPACK FOOTER //
// ./src/backoffice/components/billing/InvoiceBreakdownModal.tsx